import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const WarningColors = createInteractiveColorVars('warning');
const WarningColorsLightValues = Object.freeze({
    base: {
        default: '#FE9D24',
        action: '#C9760E',
        active: '#FE9D24',
        activeAction: '#C9760E',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});
const WarningColorsDarkValues = Object.freeze({
    base: {
        default: '#FFC13C',
        action: '#D69200',
        active: '#FFC13C',
        activeAction: '#D69200',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});

export { WarningColors, WarningColorsDarkValues, WarningColorsLightValues };
